import { ref, computed, watch } from '@vue/composition-api'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import store from '@/store'
import ability from '@/libs/acl/ability'
import { debounce } from 'lodash'
import useFilterCounter from '@/components/Filters/useFiltersCount'

export default function useList() {
  const refListTable = ref(null)
  const toast = useToast()

  const tableColumns = [
    { 
      label: "omnicloud_fr.face.image",
      key: "image",
      sortable: false
    },
    {
      label: 'ID',
      key: 'employee_id',
      sortable: true
    },
    {
      label: 'employees.first_name',
      key: 'first_name',
      sortable: true
    },
    {
      label: 'employees.last_name',
      key: 'last_name',
      sortable: true
    },
    {
      label: 'companies.title',
      key: 'company.name',
      sortable: true
    }
  ]

  if (ability.can('update', 'Employees') || ability.can('delete', 'Employees')) {
    tableColumns.splice(0, 0, { label: 'actions.name', key: 'actions' })
  }

  const perPage = ref(10)
  const totalList = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('first_name')
  const isSortDirDesc = ref(false)

  store.dispatch('companies/getAll')

  const companiesOptions = computed(() => store.getters['companies/getSelectedItems'])

  const dataMeta = computed(() => {
    const localItemsCount = refListTable.value ? refListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalList.value,
    }
  })

  const fetchList = (ctx, callback) => {
    store.dispatch('employees/getAll', {
      q: searchQuery.value,
      max: perPage.value,
      'page[n]': currentPage.value,
      sortBy: sortBy.value,
      sortDesc: isSortDirDesc.value
    })
      .then(response => {
        callback(response.data)
        totalList.value = response.meta.total
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error obteniendo la información',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }


  const refetchData = () => {
    refListTable.value.refresh()
  }

  watch([currentPage, perPage], () => {
    refetchData()
  })

  watch([searchQuery], debounce(() => {
    refetchData()
  }, 500))

  const filters = ref({})
  const filtersCount = useFilterCounter(filters)

  const buildFilters = () => {
    filters.value = {
      /* code: eventCodeFilter.value,
      id_type_alarm: typeAlarmFilter.value,
      dispatch_alarm: dispatchAlarmFilter.value, */
    }
    refetchData()
  }

  const clearSearchFilters = () => {
    /* eventCodeFilter.value = null
    typeAlarmFilter.value = null
    dispatchAlarmFilter.value = null */
    buildFilters()
  }

  return {
    tableColumns,
    perPage,
    currentPage,
    totalList,
    fetchList,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refListTable,

    refetchData,
    companiesOptions
   /*  clearSearchFilters,
    buildFilters, */
    //filtersCount,
  }
}
